import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PlusIcon from "../components/common/Icons/PlusIcon";
import PageHeader from "../components/common/PageHeader";
import ApplicantTable from "../components/Applicants/ApplicantsTable";
import { useAuth } from "../context/AuthContext";

const Applicants = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { company } = useAuth();

  if (!company?.modules?.isApplicantAvailable) {
    return (
      <Container>
        <PageHeader pageTitle="Başvuru Listesi" />
        <p style={{ color: "#888", marginTop: 24 }}>Bu modül şirketiniz için aktif değil.</p>
      </Container>
    );
  }

  return (
    <Container>
      <PageHeader
        pageTitle="Başvuru Listesi"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Başvuru"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <ApplicantTable />
    </Container>
  );
};

export default Applicants;
